const partners: {
  urlPath?: string;
  imagePath: string;
}[] = [
  {
    urlPath: 'http://www.carlipa.com/',
    imagePath: '/images/partners/partner-logo-carlipa.jpg' 
  },
  { 
    urlPath: 'http://www.west.fr/',
    imagePath: '/images/partners/partner-logo-west.jpg' 
  },
  { 
    urlPath: 'http://www.transitions.com/',
    imagePath: '/images/partners/partner-logo-transitions.jpg' 
  },
  { 
    urlPath: 'https://www.sonacom.fr/',
    imagePath: '/images/partners/partner-logo-sonacom.png' 
  },
  { 
    urlPath: 'http://www.sedona.fr/',
    imagePath: '/images/partners/partner-logo-sedona.jpg' 
  },
  { 
    urlPath: 'http://www.fittingbox.com/',
    imagePath: '/images/partners/partner-logo-fitting-box.jpg' 
  },
  { 
    urlPath: 'http://www.fgxi.com/',
    imagePath: '/images/partners/partner-logo-fgx.jpg' 
  },
  { 
    urlPath: 'http://www.angie.fr/',
    imagePath: '/images/partners/partner-logo-angie.jpg' 
  }
];

export default partners;
